<gpd-multi-step-popup
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  i18n-title="@@addToProject"
  title="Add to Project"
  [steps]="steps"
  i18n-finishText="@@add"
  finishText="Add"
  width="56vw"
  height="auto"
  [maxHeight]="'82vh'"
  (onCancelClicked)="close()"
  (onNextClicked)="onNextClicked()"
  (onFinishClicked)="onFinishClicked()"
>
</gpd-multi-step-popup>

<ng-template #selectProjectStepTemplate>
  <div class="select-step">
    <dx-text-box
      class="gpd-input"
      mode="search"
      (onValueChanged)="projectGrid.instance.searchByText($event.value)"
      [width]="300"
      i18n-placeholder="@@searchProject"
      placeholder="Search project"
    ></dx-text-box>

    <div class="grid-tab">
      <dx-data-grid
        #projectGrid
        (onInitialized)="projectGridInstance = $event.component"
        [dataSource]="projects"
        keyExpr="id"
        class="gpd-datagrid gpd-datagrid-slim"
        [(selectedRowKeys)]="selectedProjectKeys"
        (onSelectionChanged)="onProjectSelectionChanged($event)"
        (onRowClick)="onProjectRowClick($event)"
        [showBorders]="true"
        [hoverStateEnabled]="true"
        height="auto"
        [width]="'100%'"
        [scrolling]="{ mode: 'standard', useNative: true }"
        [paging]="{ enabled: true, pageSize: 10 }"
        [pager]="{ visible: false }"
        (onContentReady)="getProjectGridPageInfo()"
        (onOptionChanged)="onProjectGridOptionChanged($event)"
      >
        <dxo-selection mode="multiple" showCheckBoxesMode="always" [allowSelectAll]="false"></dxo-selection>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxi-column dataField="nr" i18n-caption="@@nr" caption="Nr" [width]="100"></dxi-column>
        <dxi-column dataField="title" i18n-caption="@@name" caption="Name"></dxi-column>
        <dxi-column dataField="status" i18n-caption="@@status" caption="Status" [width]="140"></dxi-column>
      </dx-data-grid>
      <app-gpd-pagination
        [currentPage]="projectGridCurrentPage"
        [totalPages]="projectGridTotalPages"
        [itemsPerPage]="projectGridTotalItems === 0 ? 0 : (projectGridShowingTo - projectGridShowingFrom + 1)"
        [totalItems]="projectGridTotalItems"
        (onPageChange)="onProjectGridPageChange($event)"
      ></app-gpd-pagination>
    </div>

    <div class="hidden-validator">
      <dx-text-box [(value)]="selectionValidatorValue">
        <dx-validator>
          <dxi-validation-rule
            type="required"
            i18n-message="@@selectAProject"
            message="Please select a project"
          ></dxi-validation-rule>
        </dx-validator>
      </dx-text-box>
    </div>
  </div>
</ng-template>

<ng-template #roleStepTemplate>
  <div class="role-step">
    <div class="role-row" *ngFor="let project of selectedProjects">
      <label class="role-label">
        <span i18n="@@roleForProject">Role for {{ project.nr }} | {{ project.title }}</span>
        <span class="role-label__required">*</span>
      </label>
      <gpd-role-select [(value)]="project.role"></gpd-role-select>
    </div>
  </div>
</ng-template>
